import { HIGHLIGHT_METRIC } from '../../../../../model/caf.interface'
import { n_caf, s_caf } from '../../../../i18n/strings/auto/wording_webview'

export const returnMetricItemInfo = (metricType: HIGHLIGHT_METRIC) => {
  switch (metricType) {
    case HIGHLIGHT_METRIC.FILLER_WORD:
      return {
        skeleton_msg: s_caf.highlight.msg_filler,
      }
    case HIGHLIGHT_METRIC.SPEECH_RATE:
      return {
        skeleton_msg: s_caf.highlight.msg_speech_rate,
        graph_title: s_caf.highlight.graph_sr,
        graph_type: 'line',
      }
    case HIGHLIGHT_METRIC.REPETITION:
      return {
        skeleton_msg: s_caf.highlight.msg_repetition,
      }
    case HIGHLIGHT_METRIC.GRAMMAR:
      return {
        skeleton_msg: s_caf.highlight.msg_grammar,
      }
    case HIGHLIGHT_METRIC.SENTENCE_STRUCTURE:
      return {
        skeleton_msg: s_caf.highlight.msg_sentence_structure,
      }
    case HIGHLIGHT_METRIC.PRONUNCIATION:
      return {
        skeleton_msg: n_caf.highlight.correct.grammar18,
      }
    default:
      return { skeleton_msg: s_caf.highlight.msg_grammar }
  }
}
